// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","174":"876fd752","517":"b8d0fd6f","995":"b2aa14dc"}[chunkId] + ".js";
};